exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-1b8ec198]{margin-bottom:.3rem!important}", ""]);

// exports
